export default "__VITE_ASSET__43dc44d7__"